var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _path5, _path6, _path7, _rect8, _rect9, _rect0, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalEra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 60,
    viewBox: "0 0 182 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.911 41.3652C106.397 41.3652 105.235 42.127 104.669 43.3574H104.61V41.5312H101.797V55.418H104.649V50.2422H104.708C105.264 51.4238 106.436 52.166 107.96 52.166C110.577 52.166 112.198 50.1348 112.198 46.7656C112.198 43.3867 110.567 41.3652 107.911 41.3652ZM106.954 49.8711C105.557 49.8711 104.639 48.6602 104.639 46.7656C104.639 44.8906 105.557 43.6504 106.954 43.6504C108.379 43.6504 109.278 44.8711 109.278 46.7656C109.278 48.6699 108.379 49.8711 106.954 49.8711ZM117.715 50.1055C116.749 50.1055 116.104 49.6172 116.104 48.8359C116.104 48.0938 116.71 47.6152 117.774 47.5371L119.981 47.4004V48.1621C119.981 49.2949 118.956 50.1055 117.715 50.1055ZM116.778 52.166C118.086 52.166 119.385 51.5117 119.971 50.3984H120.03V52H122.784V44.8027C122.784 42.6934 121.036 41.3066 118.35 41.3066C115.577 41.3066 113.848 42.7031 113.741 44.7344H116.348C116.485 43.9629 117.159 43.4355 118.223 43.4355C119.297 43.4355 119.981 44.002 119.981 44.9785V45.6719L117.344 45.8281C114.737 45.9844 113.272 47.0879 113.272 48.9922C113.272 50.877 114.786 52.166 116.778 52.166ZM125.909 55.877C128.585 55.877 129.893 54.9199 130.792 52.2344L134.395 41.5312H131.387L129.161 49.7148H129.112L126.885 41.5312H123.751L127.393 52.0098C127.413 52.0488 127.305 52.4688 127.305 52.5078C127.11 53.3379 126.592 53.6699 125.547 53.6699C125.44 53.6699 124.922 53.6699 124.835 53.6504V55.8477C124.922 55.8672 125.811 55.877 125.909 55.877ZM135.43 52H138.282V45.6816C138.282 44.5098 139.014 43.6895 140.098 43.6895C141.153 43.6895 141.788 44.3535 141.788 45.4766V52H144.532V45.6426C144.532 44.4805 145.245 43.6895 146.329 43.6895C147.432 43.6895 148.038 44.3535 148.038 45.5645V52H150.889V44.8516C150.889 42.7422 149.512 41.3359 147.461 41.3359C145.928 41.3359 144.678 42.166 144.21 43.4844H144.151C143.799 42.1172 142.745 41.3359 141.231 41.3359C139.805 41.3359 138.682 42.166 138.243 43.4258H138.184V41.5312H135.43V52ZM157.393 43.416C158.663 43.416 159.532 44.334 159.59 45.6719H155.147C155.245 44.3633 156.143 43.416 157.393 43.416ZM159.629 48.7969C159.366 49.5977 158.565 50.1152 157.52 50.1152C156.065 50.1152 155.118 49.0898 155.118 47.5957V47.4199H162.335V46.5508C162.335 43.3672 160.411 41.3066 157.364 41.3066C154.268 41.3066 152.315 43.4746 152.315 46.8145C152.315 50.1641 154.249 52.2246 157.471 52.2246C160.059 52.2246 161.934 50.8477 162.247 48.7969H159.629ZM163.809 52H166.661V45.9941C166.661 44.6367 167.471 43.6992 168.751 43.6992C170.03 43.6992 170.674 44.4805 170.674 45.8477V52H173.526V45.252C173.526 42.8008 172.217 41.3359 169.893 41.3359C168.282 41.3359 167.178 42.0977 166.622 43.3965H166.563V41.5312H163.809V52ZM176.094 39.1191V41.5312H174.62V43.6797H176.094V49.1777C176.094 51.2188 177.051 52.0391 179.512 52.0391C180.088 52.0391 180.577 51.9902 180.87 51.9219V49.8223C180.694 49.8516 180.43 49.8711 180.176 49.8711C179.336 49.8711 178.946 49.4902 178.946 48.6895V43.6797H180.879V41.5312H178.946V39.1191H176.094Z",
    fill: "#FF1E27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.021 12.1719H143.033V17.1747H151.728C152.373 17.1747 152.895 17.6973 152.895 18.342C152.895 18.9866 152.373 19.5092 151.728 19.5092H143.033V24.678H151.021C154.474 24.678 157.274 21.8784 157.274 18.4249C157.274 14.9715 154.474 12.1719 151.021 12.1719Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.2188,
    y: 7.83789,
    width: 5.47725,
    height: 24.6787,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1758,
    y: 19.8438,
    width: 5.47725,
    height: 12.6729,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.1758,
    y: 12.5059,
    width: 5.47725,
    height: 5.50269,
    rx: 2.73862,
    fill: "#FF1E27"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.875,
    y: 7.83789,
    width: 5.47725,
    height: 24.6787,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1562 20.8431L84.4254 14.0898L92.0153 32.5155H86.87L82.1562 20.8431Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.139 20.5092L174.408 13.7559L181.998 32.1815H176.852L172.139 20.5092Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94.8379,
    y: 7.83789,
    width: 5.47725,
    height: 24.6787,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143.027,
    y: 32.1816,
    width: 6.50318,
    height: 4.85127,
    transform: "rotate(-90 143.027 32.1816)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.88073,
    height: 5.16917,
    transform: "matrix(0.999967 0.00806819 -0.00710633 0.999975 125.383 19.5098)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7741 12.5059H83.7208L76.5222 32.5156H71.0449L77.7741 12.5059Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.758 12.1719H173.705L166.507 32.1816H161.029L167.758 12.1719Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.447 23.2616L153.438 22.1777L157.194 32.0992H152.894L149.447 23.2616Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 94.8379,
    y: 32.5156,
    width: 5.83618,
    height: 12.9889,
    transform: "rotate(-90 94.8379 32.5156)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.83617,
    height: 9.21423,
    transform: "matrix(0.00644946 0.999979 -0.999973 0.00732242 68.2129 12.5059)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2188,
    width: 5.47725,
    height: 5.83618,
    rx: 2.73862,
    fill: "#FF1E27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.82 32.1765L139.113 32.2188L139.141 26.6867L130.948 26.6393C128.495 26.6251 126.516 24.6246 126.528 22.1711C126.541 19.7176 128.54 17.7402 130.993 17.7544L139.187 17.8018L139.215 12.2696L131.921 12.2273C126.412 12.1955 121.924 16.6354 121.896 22.1442C121.868 27.653 126.311 32.1447 131.82 32.1765Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5793 32.5156L48.3535 32.5156V26.9667L39.0693 26.9667C36.6083 26.9667 34.6133 24.9717 34.6133 22.5107C34.6133 20.0498 36.6083 18.0548 39.0693 18.0548L48.3535 18.0548V12.5059L39.5793 12.5059C34.0537 12.5059 29.5744 16.9852 29.5744 22.5107C29.5744 28.0363 34.0537 32.5156 39.5793 32.5156Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3426 12.5059H1.56836V18.0548H10.8526C13.3135 18.0548 15.3085 20.0498 15.3085 22.5108C15.3085 24.9717 13.3135 26.9667 10.8526 26.9667H1.56836V32.5156H10.3426C15.8681 32.5156 20.3475 28.0363 20.3475 22.5107C20.3475 16.9852 15.8681 12.5059 10.3426 12.5059Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4432 25.5117L41.055 20.5093H47.8313L44.4432 25.5117Z",
    fill: "#FF1E27"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4524 22.1777L83.565 27.1802H79.418L81.4524 22.1777Z",
    fill: "#FF1E27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.433 21.8438L173.545 26.8462H169.398L171.433 21.8438Z",
    fill: "#FF1E27"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30696 22.5102L1.65168 26.178L1.57331 18.9581L6.30696 22.5102Z",
    fill: "#FF1E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalEra);
export default __webpack_public_path__ + "static/media/DigitalEra.afbbbf571ec92fea4589c5a5c5200750.svg";
export { ForwardRef as ReactComponent };